import React, { Component } from "react";

class InterstitialNotification extends Component {

  state = {
    showNotification: true
  };

  onClickHandler = () => {
    this.setState({ showNotification: false });
  };


  render() {
    return (
      <div>
        {this.state.showNotification ?
          <div className="interstitial-alert alert-danger container show" role="alert">
            <div className="d-flex">
              <div className="p-2 text-right">
                <i className="material-icons error-icon" aria-hidden="true">error</i>
              </div>
              <div className="p-2">
                <span className="alert-body">We're sorry but the information you entered doesn't match our records.</span>
                <div className="alert-body"><span className="alert-heading">Sometimes this happens. Give it another try!</span></div>
              </div>
              <div className="ml-auto p-2">
                <button type="button" className="close" aria-label="Close" onClick={this.onClickHandler}><i
                  className="material-icons close-icon btn-close-error">clear</i></button>
              </div>
            </div>
          </div>
          : <article/>}
      </div>);
  }
}

export default InterstitialNotification;
